module.exports = __webpack_public_path__ + "img/15_16.d153d04f.png";